export default __webpack_public_path__ + "static/media/3.4884672f.jpg";